@if (!portalToHTMLBody) {
  <ng-container *ngTemplateOutlet="debugWindow"></ng-container>
}

<ng-template cdkPortal #debugWindow>
  @if (debugData$.value && !hideWindow && initialized) {
    <div
      class="debug-window"
      [style.height]="initialHeight + 'px'"
      [style.width]="initialWidth + 'px'"
      [ngClass]="minimizeWindow ? 'minimized-window' : ''"
      cdkDrag
      (cdkDragEnded)="onDragEnded($event)"
      #dragWindow>
      <div class="header" cdkDragHandle>
        <div class="window-description">
          {{ debugData$?.value?.windowName }}
        </div>
        <div class="buttons">
          @if (!minimizeWindow) {
            <div
              class="minimize debug-button"
              (click)="minimize()"
              (keydown.enter)="minimize()">
              <i class="fa fa-chevron-up" aria-hidden="true"></i>
            </div>
          }
          @if (minimizeWindow) {
            <div
              class="zoom debug-button"
              (click)="expand()"
              (keydown.enter)="expand()">
              <i class="fa fa-chevron-down" aria-hidden="true"></i>
            </div>
          }
          <div
            class="close debug-button"
            (click)="close()"
            (keydown.enter)="close()">
            <i class="fa fa-times" aria-hidden="true"></i>
          </div>
        </div>
      </div>
      @if (!minimizeWindow) {
        <div class="sub-header">
          <div class="tabs">
            @for (tab of debugData$.value?.tabs; track $index) {
              <div
                class="tab"
                [ngClass]="{active: $index === activeTabIndex}"
                (click)="selectTab($index)"
                (keydown.enter)="selectTab($index)">
                {{ tab.tabName }}
              </div>
            }
          </div>
        </div>
        <div class="content">
          @for (tab of debugData$.value?.tabs; track $index) {
            @if (activeTabIndex === $index) {
              <div class="tab-contents">
                @if (tab.tabContentType === 'JSON') {
                  <pre>{{ tab.tabContent | json }}</pre>
                }
                @if (tab.tabContentType === 'HTML') {
                  <div [innerHTML]="tab.tabContent"></div>
                }
                @if (tab.tabContentType === 'STRING') {
                  <div>{{ tab.tabContent }}</div>
                }
                @if (tab.tabContentType === 'TEMPLATE') {
                  <ng-container
                    *ngTemplateOutlet="tab.tabContent"></ng-container>
                }
              </div>
            }
          }
          <div class="content-actions">
            <button
              class="btn btn-link"
              type="button"
              (click)="copyContentToClipboard()"
              (keydown.enter)="copyContentToClipboard()">
              <i class="fa fa-clipboard" aria-hidden="true"></i>
            </button>
            @if (
              debugData$.value.tabs[activeTabIndex]?.comparableWithTabNames &&
              debugData$.value.tabs[activeTabIndex]?.comparableWithTabNames
                .length > 0
            ) {
              <div class="dropdown align-content-center" dropdown>
                <button
                  dropdownToggle
                  type="button"
                  class="btn-link btn-transparent align-middle text-dark"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="fa fa-arrows-h" aria-hidden="true"></i>
                </button>
                <div class="dropdown-menu">
                  <!-- <div class="dropdown-divider"></div> -->
                  @for (
                    compareTarget of debugData$.value.tabs[activeTabIndex]
                      .comparableWithTabNames;
                    track $index
                  ) {
                    <button
                      class="dropdown-item"
                      type="button"
                      (click)="
                        openComparison(
                          debugData$.value.tabs[activeTabIndex].tabName,
                          compareTarget
                        )
                      "
                      (keydown.enter)="
                        openComparison(
                          debugData$.value.tabs[activeTabIndex].tabName,
                          compareTarget
                        )
                      ">
                      Compare with: {{ compareTarget }}
                    </button>
                  }
                </div>
              </div>
            }
          </div>
          <div class="resize-handle" (mousedown)="onResizeMouseDown($event)">
            <i class="fa fa-expand" aria-hidden="true"></i>
          </div>
          <div
            class="debug-notification"
            [ngClass]="debugNotification$.value ? '' : 'hidden'">
            {{ debugNotification$.value }}
          </div>
        </div>
      }
    </div>
  }

  @if (diffCheckData$.value) {
    <app-debug [debugData$]="diffCheckData$"></app-debug>
  }
</ng-template>
